import { Message } from './../../models/system/message';
import { Component, OnInit, Input } from '@angular/core';
import { Globals } from '../../services/globals';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.css']
})
export class AlertsComponent implements OnInit {
  @Input() MessageList: Message[];

  constructor(public globals: Globals) { }

  ngOnInit() {
  }

}
